import metadataIndex from './stories/metadata.json' assert { type: 'json' }
import type { StoryMetadata } from './stories'

export const stories = metadataIndex as StoryMetadata[]
